// addGifts.js
'use strict';
import { ADD_GIFTS } from '../ActionTypes.js';

/**
 * Add gifts.
 * Renames the gift api `ui_type` field to `uiType` so the store keeps a single
 * camelCase key. Every `ADD_GIFTS` dispatch goes through here, so callers can
 * pass the raw api response untouched.
 * @kind action
 * @param {object} {gifts} - gifts keyed by gift id.
 * @return {Promise} Action promise.
 * @example
 * addGifts({ gifts: { 'gift-1': { id: 'gift-1', ui_type: 'pag' } } });
 * // dispatches { gifts: { 'gift-1': { id: 'gift-1', uiType: 'pag' } } }
 */
const addGifts =
  ({ gifts }) =>
  dispatch =>
    dispatch({
      type: ADD_GIFTS,
      payload: {
        gifts: Object.entries(gifts).reduce((result, [giftId, gift]) => {
          const { ui_type: uiType, ...restGift } = gift;
          result[giftId] = uiType ? { ...restGift, uiType } : restGift;
          return result;
        }, {}),
      },
    });

export default addGifts;
